import { CheckIcon } from '@heroicons/react/20/solid';
import classNames from 'classnames';
import React from 'react';

export interface SelectItemProps {
  active?: boolean;
  isSelected?: boolean;
  truncate?: boolean;
  disabled?: boolean;
  className?: string;
  onClick?: React.MouseEventHandler;
}

export const SelectItem = React.forwardRef<HTMLLIElement, React.PropsWithChildren<SelectItemProps>>(
  ({ active, isSelected, disabled, truncate = true, className, onClick, children, ...rest }, ref) => (
    <li
      {...rest}
      {...{ ref }}
      className={classNames(
        `group relative select-none py-2 pl-2 pr-9`,
        isSelected ? 'bg-brand text-white' : active && 'bg-brand text-white',
        disabled ? `cursor-default` : `cursor-pointer`,
        className
      )}
      onClick={disabled ? undefined : (event) => onClick?.(event)}
    >
      <span className={classNames('block text-sm', { truncate: truncate })}>{children}</span>

      {isSelected && (
        <span aria-hidden="true" className="absolute inset-y-0 right-0 flex items-center pr-2">
          <CheckIcon className="h-5 w-5" />
        </span>
      )}
    </li>
  )
);
